import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { getAppPortalRoot } from "../utils/appPortal";
import "./DeleteWordModal.css";

export default function GroupingConfirmModal({
  open,
  title,
  children,
  confirmLabel = "Valider",
  cancelLabel = "Annuler",
  danger = false,
  busy = false,
  confirmDisabled = false,
  className = "",
  actionsStart = null,
  onConfirm,
  onClose,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div
      className="delete-word-modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget && !busy) onClose?.();
      }}
    >
      <div
        className={`delete-word-modal grouping-confirm-modal${
          className ? ` ${className}` : ""
        }`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="grouping-confirm-modal-title"
      >
        <button
          type="button"
          className="delete-word-modal__close"
          onClick={onClose}
          disabled={busy}
          aria-label="Fermer"
        >
          <X size={18} strokeWidth={2.5} />
        </button>

        <h3
          id="grouping-confirm-modal-title"
          className="delete-word-modal__title delete-word-modal__title--gothic"
        >
          {title}
        </h3>

        <div className="delete-word-modal__text grouping-confirm-modal__body">
          {children}
        </div>

        <div
          className={`delete-word-modal__actions${
            actionsStart ? " grouping-confirm-modal__actions--split" : ""
          }`}
        >
          {actionsStart}
          <button
            type="button"
            className="delete-word-modal__btn delete-word-modal__btn--cancel"
            onClick={onClose}
            disabled={busy}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`delete-word-modal__btn delete-word-modal__btn--confirm${
              danger ? " grouping-confirm-modal__confirm--danger" : ""
            }`}
            onClick={onConfirm}
            disabled={busy || confirmDisabled}
          >
            {busy ? "Validation…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    getAppPortalRoot()
  );
}
